import { BrowserRouter, HashRouter } from "react-router-dom";
import 'react-rangeslider/lib/index.css'
import "react-datepicker/dist/react-datepicker.css";
import 'react-device-frameset/styles/marvel-devices.min.css'
import "./App.scss";
import Routing from "./routing/Routing";
import { AxiosInterceptor } from "config/axiosInstance";
import "react-phone-input-2/lib/bootstrap.css";
import { Provider } from "react-redux";
import appStore from "store/appStore";
import "./index.css";
import ScrollToTop from "routing/ScrollTop";

function App() {
  return (
    <div className="App">
      {/* <HashRouter> */}
      <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
        <Provider store={appStore}>
          <AxiosInterceptor>
            {/* <AppLogout> */}
            <ScrollToTop />
            <Routing />
            {/* </AppLogout> */}
          </AxiosInterceptor>
        </Provider>
      </BrowserRouter>
      {/* </HashRouter> */}
    </div>
  );
}

export default App;
